import {
    axios
} from './axios2';
import {
    _url
} from './http';

export default {
    get: (url, payload = {}) => {
        const totalUrl = url + querify(payload);
        return axios.get(_url(totalUrl));
    },
    post: (url, payload = {}) => {
        return axios.post(_url(url), payload);
    },
    put: (url, payload) => {
        return axios.put(_url(url), payload);
    },
    delete: (url, payload) => {
        const totalUrl = url + querify(payload);
        return axios.delete(_url(totalUrl));
        // return axios.post(totalUrl);
    },
    querify: (params) => querify(params)

}

const querify = (params) => {
    if (!params || !Object.keys(params).length) return '';
    const arrParams = [];
    Object.keys(params).map(key => (typeof params[key] !== 'undefined' && params[key] !== '' && params[key] !== null) && arrParams.push(paramValue(key, params)));
    const union = !!arrParams.length ? '?' : '';
    const queryString = union + arrParams.join('&');
    return queryString;

}
const paramValue = (key, data) => {
    if (Array.isArray(data[key])) {
        return `${key}=${data[key].join(',')}`
    }
    return `${key}=${data[key]}`;
}
